<div class="rvb">
    <!-- Hero -->
    <div class="rvb__hero">
        <div class="rvb__hero-bg"></div>
        <div class="rvb__hero-stripe"></div>
        <div class="rvb__hero-inner">
            <div class="rvb__eyebrow">
                <span class="rvb__eyebrow-dot"></span>Free Buyer Tool
            </div>
            <h1 class="rvb__h1">
                Rent vs. Buy<br /><span class="rvb__h1-accent">Calculator</span>
            </h1>
            <p class="rvb__hero-sub">
                Every dimension of the decision — monthly costs, opportunity
                cost, equity, taxes, appreciation, and 30-year projections — in
                one place.
            </p>
        </div>
    </div>

    <!-- Page body -->
    <div class="rvb__body">
        <hs-rvb-winner-banner
            [summary]="svc.summary()"
            [horizon]="svc.inputs().horizon"
        />

        <hs-rvb-metric-row [summary]="svc.summary()" />

        <div class="rvb__main-grid">
            <hs-rvb-controls-panel />

            <div class="rvb__right">
                <hs-rvb-chart-card
                    title="Cumulative net cost over time"
                    subtitle="Net = total cash paid minus wealth recovered (equity or investment portfolio)"
                    chartId="rvb-cost-chart"
                    buyLabel="Buy (net)"
                    rentLabel="Rent (net)"
                    [buyData]="costBuyData()"
                    [rentData]="costRentData()"
                    [labels]="chartLabels()"
                    [allowNegative]="true"
                />

                <hs-rvb-chart-card
                    title="Cumulative net wealth over time"
                    subtitle="Total assets accumulated — home equity (buyer) or investment portfolio (renter)"
                    chartId="rvb-wealth-chart"
                    buyLabel="Buy (equity)"
                    rentLabel="Rent (portfolio)"
                    [buyData]="wealthBuyData()"
                    [rentData]="wealthRentData()"
                    [labels]="chartLabels()"
                    [allowNegative]="false"
                />

                <hs-rvb-breakdown-cards
                    [summary]="svc.summary()"
                    [horizon]="svc.inputs().horizon"
                />

                <hs-rvb-methodology />
            </div>
        </div>

        <!-- CTA Band -->
        <div class="rvb__cta">
            <h2 class="rvb__cta-title">
                Ready to Buy?<br /><em>Skip the Agent.</em>
            </h2>
            <p class="rvb__cta-sub">
                HomeShark gives you the tools, MLS access, and guidance to
                purchase a home in Georgia without a buyer's agent — and keep
                that commission in your pocket.
            </p>
            <div class="rvb__cta-btns">
                <a routerLink="/search" class="rvb__btn-primary"
                    >Start Searching Homes →</a
                >
                <a routerLink="/how-it-works" class="rvb__btn-outline"
                    >See How It Works</a
                >
            </div>
        </div>
    </div>
</div>
